export class CurrentMilestone {
    PaymentTermID: number;
    Description: string;
    order_id: string;
    Name: string;
    EmailId: string;
    MobileNo: string;
    PrefixCode: string;
    PayableAmountInclusiveOfTax: number;
    LatePaymentCharges: number;
    TotalPayableAmount: number;
    NoOfDaysDelayed: number;
    HasHomeLoan :boolean;
    AmountExclusiveOfTax: number;
    AmountTax: number;
    OtherCharges: number;
    OtherChargesTax: number;
    TDS: number;
}
